<template>
  <v-row id="notificationPendingApprovals" column fill-height>
    <pending-obligation
      v-model="selectedPendingObligation"
      @close="selectedPendingObligation = null"
      @cancel="selectedPendingObligation = null"
      @save="selectedPendingObligation = null"
    >
    </pending-obligation>
    <v-list three-line dense>
      <v-subheader>{{ resx.labels.pendingApprovalsTitle }}</v-subheader>
      <v-list-item
        v-for="item in items"
        :key="item._id"
        @click="selectedPendingObligation = item"
        ripple
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.data.obligation.name }}</v-list-item-title>
          <v-list-item-subtitle>{{
            item.data.contractorCompany.contractor.name
          }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{
            timeFromNow(item.createdAt)
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-btn
      id="viewAll"
      :to="{ name: 'additionalObligations' }"
      block
      small
      color="primary"
      >{{ resx.labels.viewAll }}</v-btn
    >
  </v-row>
</template>

<script>
import moment from "moment";
import pendingObligation from "../../obligations/pending-obligation.view.vue";

export default {
  name: "notificationPendingApprovals",
  components: { pendingObligation },
  data() {
    return {
      selectedPendingObligation: null
    };
  },
  methods: {
    timeFromNow(dateTime) {
      return moment(dateTime).fromNow();
    }
  },
  props: {
    items: { type: Array }
  }
};
</script>

<style lang="scss">
#notificationPendingApprovals {
  #viewAll {
    margin-bottom: 0;
    margin-top: 0;
  }
}
</style>
